module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section07_01_american-village-6b42f44c0165777f1ab1e718ba544070.jpg";